// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"css-2nhzBA1RlN","footer_staticLogo":"css-3Md6ZNN7n6","footer_address":"css-2Itn6GC8xa"};